import { AvailableAmount } from "../presentation/interfaces/available-amount.interface";
import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

export async function getAvailableAmount(employeeId: number, token: string, updateToken: (newToken: string) => void): Promise<AvailableAmount | null> {
    try {
        const response = await interceptorFetch(`available-amount/employee/${employeeId}`, token, updateToken, { method: "GET" });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Error fetching available balance' }));
            throw createApiError(errorData, response.status);
        }
        return await response.json();

    } catch (error) {
        throw normalizeToApiError(error);
    }
}

